var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"notice-bar",on:{"click":_vm.tipClick}},[_c('div',{ref:"wrap",staticClass:"notice-bar__wrap"},[_c('div',{ref:"content",staticClass:"notice-bar__content",style:(_vm.contentStyle)},[_vm._v(_vm._s(_vm.text))])])])}
var staticRenderFns = []

export { render, staticRenderFns }